import useNextRouterHook from "../../hooks/useNextRouterHook";
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import Privacy from "../../components/legals/privacy";
import CookiesBanner from "../../components/legals/cookiesBanner";
import NextHead from "../../components/header/nextHead";

function PrivacyPolicy() {
    const routerTo = useNextRouterHook();
    return (
        <>
            <NextHead>
                <meta name="robots" content="noindex" />
            </NextHead>
            <Header routerTo={routerTo} />
            <Privacy />
            <CookiesBanner />
            <Footer />
        </>
    )
}

export default PrivacyPolicy;